<template>
  <div>
    <Modal :show="showModal" @close="closeModal">
      <div class="absolute text-gray-500 z-50 right-0 cursor-pointer" @click="closeModal">
        <span class="material-icons">cancel</span>
      </div>
      <PlyrVideo>
          <div class="plyr__video-embed rounded-md shadow-md hover:shadow-lg border-gray-100">
              <iframe
                  height="200"
                  style="width: 100%"
                  class="rounded-2xl"
                  :src="video"
                  allowfullscreen allowtransparency
                  allow="autoplay"
                  loading="lazy"
              >
              </iframe>
          </div>
      </PlyrVideo>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/Jetstream/Modal.vue";
require('vue-plyr/dist/vue-plyr.css');
let PlyrVideo = require('vue-plyr').default;

export default {
  emits: [ 'close' ],
  components: {
    Modal, PlyrVideo
  },
  props: {
    showPlayer: {
      type: Boolean,
      default: false,
    },
    video: {
      type: String,
      default: false,
    }
  },
  data() {
    return {
      //
    };
  },
  computed:{
    showModal(){
      return this.showPlayer;
    },
  },
  methods: {
    closeModal(){
        this.showModal = false;
        this.$emit('close', true);
    },
  },
};
</script>